import styled from "styled-components";
import { HeroBanner } from "../../shared/icons";
import { PageContainer } from "../../styles/sharedStyled";
import { Button } from "../../components/Buttons";
import { DigitalNFT } from "../../shared/icons";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${HeroBanner});
  background-size: cover;
  background-position: center;
  padding: 50px 0;
`;

const List = styled.ul`
  display: flex;
  list-style: none; /* Removes default bullet points */
  padding: 0;
  margin: 0;
  width: 100%;
`;

const ListItem = styled.li`
  flex: 1;
  padding: 20px;

  &:first-child {
    text-align: left;
  }

  &:last-child {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h1 {
    font-size: 48px;
    font-weight: 400;
    margin: 10px 0;
    color: #ffffff;
    line-height: 57.84px;
  }

  p {
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #ffffff;

    span {
      font-size: 15px;
      font-weight: 400;
      color: #ffffff;
      position: relative;
      padding-left: 15px;

      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 5px;
        background: #fff;
        width: 8px;
        height: 8px;
        border-radius: 50px;
      }
    }
  }

  img {
    max-width: 100%;
    height: auto;
    object-fit: cover;
  }
`;

// Updated HeroSection component
const HeroSection = () => {
  return (
    <Wrapper>
      <PageContainer>
        <List>
          <ListItem>
            <p>
              <span>EcoNFT</span>
            </p>
            <h1>Reach Out to Us: We’re Here to Help with Any Questions</h1>
            <p>
              Have questions or need assistance? Our team is ready to help you
              with any inquiries. Whether you need support, more information, or
              want to share feedback, don’t hesitate to reach out. We value your
              input and are here to ensure you have the best experience
              possible.
            </p>
            <Button variant="primary">Contact Us Now</Button>
          </ListItem>
          <ListItem>
            <img src={DigitalNFT} alt="banner img" />
          </ListItem>
        </List>
      </PageContainer>
    </Wrapper>
  );
};

export default HeroSection;
